<template>
  <div id="m-mobile-h">
    <div style="position: fixed;top: 0;width: 100vw;background-color:#fff;z-index: 999;">
      <div>
        <img src="../../../assets/h-img2.png">
        <div class="list-btn" @click="show = true">
            <van-icon name="wap-nav"  style="font-size: 2.25rem!important;" />
        </div>
      </div>
    </div>
    <van-popup v-model="show" get-container="body" position="right" :style="{ height: '100%' , width: '13rem' , paddingLeft: '2rem'}"  :closeable="true" :lock-scroll="false">
                <div class="dra-list">
                  <p @click="$router.push({path: '/mobile'})">首页</p>
                  <p style="margin-bottom: 1.8rem;">解决方案</p>
                  <div v-for="(item,index) in solutions">
                    <p @click="toDetail(item)" v-if="index !== 0 && index !== 6">{{item.fsolutionName}}</p>
                  </div>
                  <p @click="$router.push({path: '/mobileNews'})">新闻中心</p>
                  <p @click="$router.push({path: '/mobileEmploys'})">招贤纳士</p>
                </div>
    </van-popup>
  </div>
</template>

<script>
  import axios from "../../../../static/js/commonAxios";

  export default {
    name: "mheader",
    data(){
      return{
        show: false,
        solutions: []
      }
    },
    mounted(){
      this.getSolutionDate()
    },
    methods: {
      getSolutionDate(){
        axios.get('/api/solution').then((res) => {
          if(res.data.success){
            this.solutions = res.data.items
          }else{
            this.$message.error(res.data.msg)
          }
        })
      },
      toDetail(item) {
        this.$store.commit({
          type: 'setMemu',
          name: 'solutionId',
          value: item.fsolutionId
        })
        this.$router.push({path: '/mobileSolutionDetail'})
      }
    },
  }
</script>

<style>
  #m-mobile-h {
    /*position: fixed;*/
    /*height: 3.25rem;*/
    background-color: #fff;
    top: 0;
  }
#m-mobile-h div div{
    position: relative;
    height: 3.25rem;
    background-color: #fff;
    top: 0;
  z-index: 9999;
}
  #m-mobile-h div div div {
    height: 3.25rem;
    width: 3.25rem;
    position: absolute;
    right: 0;
    z-index: 99;
  }
  #m-mobile-h div div div .van-icon-wap-nav {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50% , -50%);
  }
#m-mobile-h div div img {
  position: absolute;
  width: 7.31rem;
  left: 1.25rem;
  top: 50%;
  transform: translateY(-50%);
}
  #m-mobile-h .list-btn i {
    font-size: 2.25rem!important;
  }
  .dra-list{
    margin-top: 5.3rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .dra-list p {
    font-size: 0.94rem;
    font-weight: 400;
    color: #000000;
    margin-bottom: 2.5rem;
  }
  .dra-list div p{
    font-size: 0.88rem;
    font-weight: 300;
    color: #999999;
    margin-bottom: 1.47rem;
    margin-left: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Mobile/common/header.vue